import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as _ from 'lodash';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { debounceTime, filter, forkJoin, Subject } from 'rxjs';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import * as moment from 'moment';
import { LineItemType } from 'src/app/enums/enums';
import { BillingService } from 'src/app/services/core/billing/billing.service';

@UntilDestroy()
@Component({
  selector: 'app-invoice-trips',
  templateUrl: './invoice-trips.component.html',
  styleUrls: ['./invoice-trips.component.css']
})
export class InvoiceTripsComponent implements OnInit {
  @Input() preFundingSources:any;
  @Input() fundingSources:any;
  // @Input() preFundingSources:any;
  @Input() companies?:any;
  @Input() type: 'company' | 'fundingsource' = 'company';
  @Output() viewTripDetails = new EventEmitter<string>();
  @Output() onSelectTrips = new EventEmitter<any>();
  @Output() onSetGlobalLineItemType = new EventEmitter<string>();
  filteredTrips: any = [];
  todayDate: any = [];
  selectedMember:any = ''
  selectedFundingSource:any = '';
  selectedCompany:any = '';
  search: any;
  trips: any = [];
  tripMembers:any = [];
  selectedTrips:any = [];
  currentPage = 1;
  totalResults = 0;
  totalPages = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  searchSubject = new Subject<string>();
  tripId: any;
  fundingSourceList: any;
  // preFundingSources: any = {};
  user: any;
  lineItemType = LineItemType.SALES_ITEM;

  constructor(
    private sharedDataService: SharedDataService,
    private billingService: BillingService,

  ) {}

  ngOnInit() {
    this.initSearch();
    this.getUser();
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        this.todayDate = [
          moment().tz(this.user.timeZone).startOf("day"),
          moment().tz(this.user.timeZone).endOf("day"),
        ];
        this.getAllTrips(this.currentPage);
      }
    })
  }

  getAllTrips(page: any) {
    let queryparams: any = {
      limit: 50,
      page,
      status: ['completed', 'cancelled'],
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      sortBy: 'pickup.time:asc',
      payment:'unpaid'
    }

    if (this.selectedMember) {
      queryparams.member = this.selectedMember;
    }

    if (this.type=='fundingsource'&&this.selectedFundingSource) {
      queryparams.fundingsource = this.selectedFundingSource.id;
    }
    if (this.type=='company'&&this.selectedCompany) {
      queryparams.company = this.selectedCompany;
    }

    if (this.search) {
      const trimmedSearch = this.search.trim();
      queryparams.search = trimmedSearch;
    }
    const tripsRequest =
    this.type === 'fundingsource'
      ? this.billingService.getFundingSourceBillingTrips(queryparams)
      : this.billingService.getBillingTrips(queryparams);
    
    tripsRequest.pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
          this.trips = data.results;
          this.filteredTrips = this.trips;
          let members = [];
          members = this.filteredTrips.map((trip: any) => trip.member);
          this.tripMembers = _.uniqBy(members, 'id');

          // SYNC selected trips
          this.filteredTrips.forEach((t: any) => {
            t.isSelected = this.selectedTrips.some((s: any) => s.id === t.id);
          });

          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;

          // this.selectedTrips = this.selectedTrips.filter((s: any) =>
          //   this.filteredTrips.some((f: any) => f.id === s.id)
          // );

        }
      })
  }

  setType(type: any) {
    this.lineItemType = type;
    this.onSetGlobalLineItemType.emit(this.lineItemType);
  }

  initSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search: any) => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getAllTrips(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  onDateTimeChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
    
    this.selectedTrips = [];
    this.filteredTrips.forEach((t:any) => t.isSelected = false);
    this.onSelectTrips.emit({
      action: 'clearAll',
      selectedTrips: []
    });

    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  onSelectMember(evt:any){
   this.selectedMember = evt || null;
     this.getAllTrips(this.currentPage = 1);
  // this.applyFilters();

  }

  onChange(){
     this.getAllTrips(this.currentPage = 1);
  }


  onSelectAllTrips(event: any) {
    const checked = !!event?.target?.checked;
    this.filteredTrips.forEach((trip: any) => trip.isSelected = checked);

    this.selectedTrips = checked ? [...this.filteredTrips] : [];

    this.onSelectTrips.emit({
      action: 'selectAll',
      isSelected: checked,
      trips: this.filteredTrips,
      selectedTrips: this.selectedTrips
    });
  }

  isAllFilteredSelected() {
    if (!this.filteredTrips.length) return false;
    return this.filteredTrips.every((t: any) => t.isSelected);
  }

  onSelectTrip(trip?: any) {
    if (trip) {
      const idx = this.selectedTrips.findIndex((t: any) => t.id === trip.id);
      if (idx > -1) {
        trip.isSelected = false;
        this.selectedTrips.splice(idx, 1);
      } else {
        trip.isSelected = true;
        this.selectedTrips.push(trip);
      }
      this.onSelectTrips.emit({
        action: 'toggle',
        trip: trip,
        isSelected: trip.isSelected,
        selectedTrips: this.selectedTrips
      });
    }
  }

  getRates(trip: any) {
    const fare = this.type === 'company' ? trip?.offeredFare : trip?.fare;
    const specialRate = (this.type === 'company' ? trip?.specialRate : trip?.preSpecialRate) || 0;
    const isBillableCancel = trip?.status === 'cancelled' && !!trip.flags?.isBillable;
    const cancelRate = isBillableCancel && !trip.flags?.isNoShow ? fare?.cancelBreakdown?.cancelCharges || 0 : 0;
    const noShowRate = isBillableCancel && trip.flags?.isNoShow ? fare?.cancelBreakdown?.noShowCharges || 0 : 0;
    return {
      fare: fare?.total || 0,
      specialRate,
      cancelRate,
      noShowRate,
      payment: trip?.status === 'cancelled' ? cancelRate || noShowRate : specialRate > 0 ? specialRate : fare?.total || 0,
    };
  }

  opendetailModal(trip: any) {
    this.tripId = trip.id;
    this.viewTripDetails.emit(this.tripId);
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllTrips(page);
  }
}
